import { useCallback } from "react";
import { MenuItem } from "@mui/material";
import type { TimeWindowRecentEntry } from "../../../../TimeWindow.recent.types";
import { getRecentEntryLabel } from "../../hooks/useTimeWindowRecentHistory";

interface TimeWindowRecentlySelectedOptionsProps {
  recent: TimeWindowRecentEntry[];
  setTimeWindow: (value: TimeWindowRecentEntry) => void;
  pushRecent: (entry: TimeWindowRecentEntry) => void;
}

const TimeWindowRecentlySelectedOptions = ({
  recent,
  setTimeWindow,
  pushRecent,
}: TimeWindowRecentlySelectedOptionsProps) => {
  const handleSelect = useCallback(
    (entry: TimeWindowRecentEntry) => () => {
      setTimeWindow(entry);
      pushRecent(entry);
    },
    [pushRecent, setTimeWindow]
  );

  const visibleRecent = recent.filter((entry) => getRecentEntryLabel(entry) !== "");

  if (visibleRecent.length === 0) {
    return null;
  }

  return visibleRecent.map((entry) => (
    <MenuItem
      key={entry}
      data-test-id="time-window-recent-option"
      onClick={handleSelect(entry)}
      className="gap-0.5 justify-between! pr-8! relative"
    >
      {getRecentEntryLabel(entry)}
    </MenuItem>
  ));
};

export default TimeWindowRecentlySelectedOptions;
